import { Avatar, Button, CircularProgress, Divider, Fab, Tab, Tabs, Grid, Tooltip, Typography, TextField, Select, MenuItem, InputAdornment, IconButton, Stack, Modal, Table, TableHead, TableRow, TableCell, TableBody, Paper, FormControl, InputLabel, } from "@mui/material";
import searchIcon from "../../icons/searchIcon.svg"
import ThreeSixtyIcon from "@mui/icons-material/ThreeSixty";
import React, { useState, useEffect, useContext } from "react";
import clearFilterImage from "../../../src/icons/clearFilter.svg";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { DataGrid, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector, GridToolbarExport, GridDensitySelector, getGridStringOperators, } from "@mui/x-data-grid";
import { TABS, ROLES, DATE_FORMATS } from "../../constants";
import { Add, AddAPhoto, AddTask, SaveAlt, SaveAltOutlined, SaveAs, ManageSearch, Send, Search } from "@mui/icons-material";
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import "../../App.css";
import { height } from "@mui/system";
import { set } from "date-fns";
const isMobile = window.innerWidth < 900;
const StaffEditorPageContainer = styled.div`
  height: ${isMobile ? `auto` : `calc(100vh - 105px)`};
  width: 100%;
  background-color: white;
  padding: 10px 15px;
  ${isMobile &&
  `
      position: relative;
      `}
`;
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 7px;
`;
const TableContainer = styled.div`
  //   height: calc(
  //     100vh - ${isMobile
    ? "56px - 20px - 82.23px"
    : "128px - 29px - 50.77px"}
  //   );
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
`;
const DataGridContainer = styled.div`
  max-width: 100%; /* Add this line to limit the width */
  margin: 0 auto; /* Center the content horizontally */
  height: 100%;
  width: 100%;
  //   border: solid 1px lightGrey;
  display: ${isMobile ? "flex" : "grid"};
  border-radius: 4px;
  ${isMobile &&
  `
    flex-direction: column;
  `}
`;
const TabsContainer = styled.div`
  ${isMobile &&
  `
    height: calc(100vh - 56px - 20px - 43.77px);
  `}
`;
const Allowances = (props) => {
  // Modal state for verify dialog
  const [verifyModalOpen, setVerifyModalOpen] = useState(false);
  const [verifyModalData, setVerifyModalData] = useState(null);
  const [approveModalOpen, setApprovedModalOpen] = useState(false);
  const [approvedModalData, setApprovedModalData] = useState(null);
  const [selectedDistanceType, setSelectedDistanceType] = useState("");
  // const [verifyRemark, setVerifyRemark] = useState("");
  const [approvedRemark, setApprovedRemark] = useState("");

  // Only allow input with at least one alphanumeric character
  const handleApprovedRemarkChange = (e) => {
    const value = e.target.value;
    if (/.*[a-zA-Z0-9].*/.test(value) || value === "") {
      setApprovedRemark(value);
    }
  };
  const location = useLocation();
  const selectedTabProp1 = location.state?.selectedTabProp;
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationModel, setPaginationModel] = useState({ page: currentPage - 1, pageSize: 20, });
  const [rowCount, setRowCount] = useState();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [rsms, setRsms] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [asms, setAsms] = useState([]);
  const [rms, setRms] = useState([]);
  const [rm, setRm] = useState("")
  const [rsm, setRsm] = useState("")
  const [asm, setAsm] = useState("")
  const [userModal, setUserModal] = useState(null);
  const [visibleEmployees, setVisibleEmployees] = useState([]);
  const [selectedMember, setSelectedMember] = useState(null);
  const [selectedTab, setSelectedTab] = useState(selectedTabProp1 || TABS.REGISTERED);
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(20)
  const [accessModulesData, setAccessModulesData] = useState([]);
  const [filter, setFilter] = useState(false);
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
  const [search, setSearch] = useState()
  const [newRows, setNewRows] = useState([])
  const [modalData, setModalData] = useState([])
  const [newOrderStatus, setNewOrderStatus] = useState("");
  const [openViewModal, setOpenViewModal] = useState(false)
  const [allowanceStatus, setAllowanceStatus] = useState("")
  const [sessions, setSessions] = useState([]); // from API
  const [selectedSession, setSelectedSession] = useState("");
  const [isDateRangeDisabled, setIsDateRangeDisabled] = useState(false);
  const [isSessionDisabled, setIsSessionDisabled] = useState(false);
  const [filteredDate, setFilteredData] = useState({});


  useEffect(() => {
    fetchSessions();
  }, []);

  const fetchSessions = async () => {
    try {
      setLoading(true);
      const response = await window.Platform.database.getAllSessions();
      // if (response?.data) {
      //   setSessions(response.data);
      // }
      if (response?.status) {
        const filterdData1 = response?.data?.filter((ele, ind) => ele?.action == "active")
        setFilteredData(filterdData1[0])
      }
      else {
        window.NotificationUtils.showError("Something Went Wrong in session")
      }
    } catch (error) {
      console.error("Error fetching sessions:", error);
      window.NotificationUtils.showError("Failed to load sessions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!startDate && !endDate) {
      setIsSessionDisabled(false);
    }
  }, [startDate, endDate]);

  // const getStartAndEndDates = () => {
  //   const now = new Date();
  //   const start = new Date(now.getFullYear(), now.getMonth(), 15);
  //   const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  //   return { start, end };
  // };

  // const getStartAndEndDates = () => {
  //   const now = new Date();
  //   const year = now.getFullYear();
  //   const month = now.getMonth(); // 0-indexed
  //   const date = now.getDate();

  //   let start, end;

  //   if (date <= 15) {
  //     start = new Date(year, month, 1);
  //     end = new Date(year, month, 15);
  //   } else {
  //     start = new Date(year, month, 16);
  //     end = new Date(year, month + 1, 0); // last day of the current month
  //   }

  //   return {
  //     start: start.toISOString().split("T")[0],
  //     end: end.toISOString().split("T")[0],
  //   };
  // };
  const getStartAndEndDates = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth(); // 0-based
    const day = now.getDate();

    let start, end;

    if (day <= 15) {
      start = new Date(year, month, 1);
      end = new Date(year, month, 15);
    } else {
      start = new Date(year, month, 16);
      end = new Date(year, month + 1, 0); // last day of the month
    }

    // format as YYYY-MM-DD in local timezone
    return {
      start: start.toLocaleDateString('en-CA'),
      end: end.toLocaleDateString('en-CA'),
    };
  };

  useEffect(() => {
    const { start, end } = getStartAndEndDates();

    if (!filter) {
      setStartDate(start);
      setEndDate(end);
    }
  }, []);

  useEffect(() => {
    // Only call fetch when dates are set
    // getUpdatedAllowances()
    if (startDate && endDate) {
      fetchEmployees();
    }
  }, [paginationModel.page, paginationModel.pageSize, filter, newOrderStatus]);


  useEffect(() => {
    fetchAccessModules();
    if (userData?.role.toLowerCase().includes('admin')) {
      getAllUsers()
    }
    if (userData?.role == 'rsm') {
      getUsers('rsm', userData?.id)
    }
    if (userData?.role == 'asm') {
      getUsers('asm', userData?.id)
    }
  }, [])

  async function getAllUsers() {
    let results = await window.Platform.database.fetchEmployees()
    if (results?.status) {
      window.NotificationUtils.showError(results.message);
      setLoading(false);
      return;
    }
    else {
      setAllUsers(results?.data)
      setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
      setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
      setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
      setLoading(false);
    }
  }

  async function getUsers(role, id) {
    if (id != "") {
      let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
      if (role == 'rsm') {
        setAsms(results?.data)
        setRms(results?.data1)
      }
      if (role == 'asm') {
        setRms(results?.data)
      }
    } else {
      if (role == 'rsm') {
        setRm("")
        setAsm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
        setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
      }
      if (role == 'asm') {
        setRm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
      }
    }

  }


  const fetchAccessModules = async () => {
    try {
      setLoading(true);
      let data = {
        pageNumber: paginationModel.page,
        recordPerPage: paginationModel.pageSize,
        userId: userData?.id,
        moduleId: "2mcEyrlAXR"
      }
      let results = await window.Platform.database.fetchAccessModules(data);
      if (results?.status) {
        window.NotificationUtils.showError(results?.message || "Something went wrong");
        setLoading(false);
        return;
      }
      else {
        const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
        setAccessModulesData(jsonArrayWithId);
      }
    } catch (error) {
      console.error(error);
    }
    finally {
      setLoading(false)
    }
  }


  const verifyAllowance = async (data1, selectedDistance, remark) => {
    setLoading(true);
    try {
      const payload1 = {
        status: data1.status,
        amount: selectedDistance,
        ownerId: data1.data1.userId,
        date: data1.data1.visitDate,
        // verifyRemark: remark,
      };
      // console.log(payload1, "11111111111111122222233333333");
      // return;

      let results = await window.Platform.database.verifyAllowance(payload1);
      if (results?.status === false) {
        setLoading(false);
        setVerifyModalOpen(false);
        setSelectedDistanceType("");
        fetchEmployees();
        // setVerifyRemark("");
      } else {
        window.NotificationUtils.showError("Error Fetching Data");
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      window.NotificationUtils.showError("Something Went Wrong");
    } finally {
      setLoading(false);
    }
  }

  const approveAllowance = async (approvedModalData1) => {
    // console.log(approvedModalData1, "sdsdddd");
    setLoading(true);
    try {
      const payload1 = {
        status: approvedModalData1.status,
        ownerId: approvedModalData1.data1.userId,
        approvedRemark: approvedRemark,
        id: approvedModalData1.data1.updateAllowanceId,
        date: approvedModalData?.data1?.visitDate
      };
      // console.log(payload1, "payload");
      // return;
      let results = await window.Platform.database.approveAllowance(payload1);
      if (results?.status === false) {
        setLoading(false);
        setApprovedModalOpen(false);
        fetchEmployees();
        setApprovedRemark("");
      } else {
        window.NotificationUtils.showError("Error Fetching Data");
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      window.NotificationUtils.showError("Something Went Wrong");
    } finally {
      setLoading(false);
    }
  }

  const handleOpenViewModal = (id) => {
    console.log(id, "isdsdsdsd")
    setModalData(id)
    setOpenViewModal(true);
  }

  const handleCloseViewModal = () => {
    setOpenViewModal(false);
    setModalData([]);
  }

  const formatDate1 = (dateStr) => {
    if (!dateStr) return "N/A";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const schoolColumns = () => {
    const stringOperators = getGridStringOperators().filter((op) =>
      ["contains"].includes(op.value)
    );

    let result = [
      {
        field: "name11",
        headerName: "User Name",
        width: 200,
        filterable: false,
        sortable: false,
        valueGetter: (params) => {
          let name = params.row.name || "N/A"
          return name;
        },
        renderCell: (params) => {
          let name = params.row.name || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "empId1",
        headerName: "Emp ID",
        width: 100,
        filterable: false,
        sortable: false,
        valueGetter: (params) => {
          let name = params.row.userName || "N/A"
          return name;
        },
        renderCell: (params) => {
          let name = params.row.userName || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "role1",
        headerName: "Role",
        minWidth: 200,
        valueGetter: (params) => {
          let name = params.row?.roleName || "N/A";
          return name || "N/A"
        },
        sortable: false,
        filterOperators: stringOperators,
        renderCell: (params) => {
          let name = params.row?.roleName || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "reportingManagerName",
        headerName: "Reporting Manager",
        minWidth: 210,
        valueGetter: (params) => {
          let name = params.row.reportingManagerName;
          return name;
        },
        sortable: false,
        filterOperators: stringOperators,
        renderCell: (params) => {
          let name = params.row.reportingManagerName || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "visitDate",
        headerName: "Date",
        minWidth: 110,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          return (
            <Tooltip title={params.row.visitDate || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}> {formatDate1(params.row.visitDate) || "N/A"} </Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "View",
        headerName: "View",
        minWidth: 140,
        sortable: false,
        renderCell: (params) => {
          return (
            <>
              <Tooltip>
                <span>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleOpenViewModal(params.row)}
                    sx={{ minWidth: "80px" }}
                  >
                    {"View"}
                  </Button>
                </span>
              </Tooltip>
              <Modal open={openViewModal} onClose={handleCloseViewModal}>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "80%",
                    maxWidth: 900,
                    bgcolor: "white",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    maxHeight: "90%",
                    overflowY: "auto",
                  }}
                >
                  <Typography variant="h6" component="h2" mb={5} style={{ textAlign: "center" }}>
                    Allowances
                  </Typography>
                  <div>
                    <div className="row mb-3 mt-2">
                      <div className="col-md-6">
                        <b> User Name :</b> {modalData && modalData?.name || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>Emp ID : </b> {modalData && modalData?.userName || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3 mt-2">
                      <div className="col-md-6">
                        <b> Role :</b> {modalData && modalData?.roleName || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>Reporting Manager : </b> {modalData && modalData?.reportingManagerName || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3 mt-2">
                      <div className="col-md-6">
                        <b> Date :</b> {modalData && formatDate1(modalData?.visitDate) || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b> Attendance Status :</b> {modalData && modalData?.Attendence_status || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3 mt-2">
                      <div className="col-md-6">
                        <b>Work Type : </b> {modalData && modalData?.work_type || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b> Visit Count : </b>{modalData && modalData?.visitCount || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <b>Total Working Hours :</b> {modalData && modalData?.totalWorkingHours || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>School Working Time :</b> {modalData && modalData?.school_working_time || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <b>School + Travel Time :</b> {modalData && modalData?.school_plus_travel_time || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>Vehicle Type :</b> {modalData && modalData?.vehicleType || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <b>Start Reading :</b> {modalData && modalData?.start_reading || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>End Reading :</b> {modalData && modalData?.end_reading || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-6">
                        <b>Total Distance (User Reported) :</b> {modalData && modalData?.userGeneratedDistance || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>Total Distance System Reported :</b> {modalData && modalData?.systemGenerated_distance || "N/A"}
                      </div>
                    </div>
                    <div className="row mb-3">

                      <div className="col-md-6">
                        <b>Location of Work :</b> {modalData && modalData?.visitType == "Out Station" ? "Out Station" : "Home Location" || "N/A"}
                      </div>
                      {modalData && modalData?.visitType == "Out Station" && <div className="col-md-6">{console.log("city category", modalData?.city)}
                        <b>City Category :</b>{" "}
                        {/* {modalData?.city
                          ? `${JSON.parse(modalData.city)?.name} (${JSON.parse(modalData.city)?.category})`
                          : "N/A"} */}
                        {modalData?.city || "N/A"}
                      </div>}
                    </div>

                  </div>
                  <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button onClick={handleCloseViewModal} variant="contained" color="primary">
                      Close
                    </Button>
                  </Box>
                </Box>
              </Modal>
            </>
          );
        },
      },
      // userData?.role != "asm" && {
      //   field: "approval11Status",
      //   headerName: "Status",
      //   minWidth: 120,
      //   valueGetter: (params) => {
      //     let name = params.row.approvalStatus;
      //     return name;
      //   },
      //   sortable: false,
      //   filterOperators: stringOperators,
      //   renderCell: (params) => {
      //     let name = params.row.approvalStatus === 0 ? "Verified" : params.row.approvalStatus == "1" ? "Approved" : "Pending" || "N/A";
      //     return (
      //       <Tooltip title={name || "N/A"}>
      //         <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>   <svg
      //                   xmlns="http://www.w3.org/2000/svg"
      //                   height="20px"
      //                   viewBox="0 0 24 24"
      //                   width="20px"
      //                   fill="#00ff26ff"
      //                 > </svg>{name || "N/A"}</Typography>
      //       </Tooltip>
      //     );
      //   },
      // },
      userData?.role != "asm" && {
        field: "approval11Status",
        headerName: "Status",
        minWidth: 120,
        valueGetter: (params) => {
          let name = params.row.approvalStatus;
          return name;
        },
        sortable: false,
        filterOperators: stringOperators,
        renderCell: (params) => {
          let name =
            params.row.approvalStatus === 0
              ? "Verified"
              : params.row.approvalStatus == "1"
                ? "Approved"
                : params.row.approvalStatus == "2" ? "Rejected" : "Pending"
                  || "N/A";

          return (
            <Tooltip title={name || "N/A"}>
              <Typography
                variant="inherit"
                sx={{ color: "black", fontSize: "12px", fontWeight: "500", display: "flex", alignItems: "center", gap: "4px" }}
              >
                {params.row.approvalStatus == 0 ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="20px"
                    viewBox="0 0 24 24"
                    width="20px"
                    fill="#00ff26"
                  >
                    <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z" />
                  </svg>
                )
                  :
                  params.row.approvalStatus == null || params.row.approvalStatus == "" ? <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#F19E39"><g><rect fill="none" height="24" width="24" /></g><g><path d="M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10C22,6.48,17.52,2,12,2z M7,13.5c-0.83,0-1.5-0.67-1.5-1.5 c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5C8.5,12.83,7.83,13.5,7,13.5z M12,13.5c-0.83,0-1.5-0.67-1.5-1.5 c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5C13.5,12.83,12.83,13.5,12,13.5z M17,13.5c-0.83,0-1.5-0.67-1.5-1.5 c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5C18.5,12.83,17.83,13.5,17,13.5z" /></g></svg>
                    :
                    params.row.approvalStatus == 1 ? <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#0000F5"><path d="M0 0h24v24H0V0zm0 0h24v24H0V0z" fill="none" /><path d="M16.59 7.58L10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" /></svg>
                      :
                      params.row.approvalStatus == 2 ? <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#EA3323"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" /></svg>
                        :
                        null}
                {name || "N/A"}
              </Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "verifiedAmount11",
        headerName: "Verified KM",
        minWidth: 150,
        valueGetter: (params) => {
          let name = params.row.approvalStatus;
          return name;
        },
        sortable: false,
        filterOperators: stringOperators,
        renderCell: (params) => {
          let name = params.row.verifiedAmount || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "verifiedBy12",
        headerName: "Verified By",
        minWidth: 210,
        valueGetter: (params) => {
          let name = params.row.verifyByName;
          return name;
        },
        sortable: false,
        filterOperators: stringOperators,
        renderCell: (params) => {
          let name = params.row.verifyByName || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "approvedBy12",
        headerName: "Action Taken By",
        minWidth: 210,
        valueGetter: (params) => {
          let name = params.row.approvedByName;
          return name;
        },
        sortable: false,
        filterOperators: stringOperators,
        renderCell: (params) => {
          let name = params.row.approvedByName || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },
      accessModulesData && accessModulesData[0]?.is_approve?.toLowerCase() != "no" && {
        field: "Approve Order",
        headerName: "Action",
        width: 120, filterable: false,
        sortable: false,
        disableExport: true,
        renderCell: (params) => {
          let ownerId = params.row?.ownerId
          return (
            <Stack direction={"row"} spacing={0}>
              {userData?.role == "asm" ? <>
                <div>
                  {params.row?.approvalStatus === 0 ?
                    //  <div variant="contained" color={params.row?.approvalStatus === 0 ? "inherit" : "warning"}>
                    // <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#75FB4C"><path d="M0 0h24v24H0z" fill="none"/><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/></svg>  Verified
                    // </div>
                    <div
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        backgroundColor: params.row?.approvalStatus === 0 ? "#ffffffff" : "#ffffffff",
                        color: "#000000ff",
                        padding: "6px 6px",
                        fontSize: "14px",
                        fontWeight: "500",
                        boxShadow: "0 2px 6px rgba(38, 35, 35, 0.1)",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="20px"
                        viewBox="0 0 24 24"
                        width="20px"
                        fill={params.row?.approvalStatus === 0 ? "#00ff26ff" : "#2bff00ff"}
                      >
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
                      </svg>
                      Verified
                    </div>

                    :
                    <>

                      {params.row?.approvalStatus == "" || params.row.approvalStatus == null ?
                        <Button ml={2} variant="contained" color={params.row?.approvalStatus === 0 ? "inherit" : "warning"}
                          onClick={() => {
                            setVerifyModalData({ data1: params.row, status: "1" });
                            setVerifyModalOpen(true);
                          }}> <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#F3F3F3"><g><rect fill="none" height="24" width="24" /><path d="M19,3H5C3.89,3,3,3.9,3,5v14c0,1.1,0.89,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.11,3,19,3z M19,19H5V7h14V19z M13.5,13 c0,0.83-0.67,1.5-1.5,1.5s-1.5-0.67-1.5-1.5c0-0.83,0.67-1.5,1.5-1.5S13.5,12.17,13.5,13z M12,9c-2.73,0-5.06,1.66-6,4 c0.94,2.34,3.27,4,6,4s5.06-1.66,6-4C17.06,10.66,14.73,9,12,9z M12,15.5c-1.38,0-2.5-1.12-2.5-2.5c0-1.38,1.12-2.5,2.5-2.5 c1.38,0,2.5,1.12,2.5,2.5C14.5,14.38,13.38,15.5,12,15.5z" /></g></svg> Verify</Button>
                        :
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "8px",
                            backgroundColor: params.row?.approvalStatus === 0 ? "#ffffffff" : "#ffffffff",
                            color: "#000000ff",
                            padding: "6px 6px",
                            fontSize: "14px",
                            fontWeight: "500",
                            boxShadow: "0 2px 6px rgba(38, 35, 35, 0.1)",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="20px"
                            viewBox="0 0 24 24"
                            width="20px"
                            fill={params.row?.approvalStatus === 0 ? "#00ff26ff" : "#2bff00ff"}
                          >
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
                          </svg>
                          Approved
                        </div>}
                    </>
                  }
                </div>
              </>
                :
                <div>
                  <Tooltip title="Click to approve Allowance"><IconButton disabled={params.row?.approvalStatus != 0} variant="extended" sx={{ color: "#008000" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setApprovedModalData({ data1: params.row, status: "1" });
                      setApprovedModalOpen(true);
                    }} >
                    {/* <ThumbUpIcon /> */}
                    <Button variant="contained" color="success"
                      sx={{
                        backgroundColor:
                          params.row?.approvalStatus != 0 ? '#ade0bbff' : '#2e7d32', // light green if "disabled"
                        color: params.row?.approvalStatus != 0 ? '#1b5e20' : '#fff',
                        opacity: 1,
                      }}
                    >Approve</Button>
                  </IconButton>
                  </Tooltip>
                  {/* <Tooltip title="Click to reject Allowance"><IconButton disabled={params.row?.approvalStatus != 0} variant="extended" sx={{ color: "red" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setApprovedModalData({ data1: params.row, status: "2" });
                      setApprovedModalOpen(true);
                    }}
                  >
                    <ThumbDownIcon />
                  </IconButton></Tooltip> */}
                </div>}
            </Stack>
          )
        },
      },
    ].filter(Boolean);
    return result;
  };

  const exportTADAExcel = async () => {
    // if (!rm && !asm) {
    //   window.NotificationUtils.showWarning("Please Select RM or ASM");
    //   return;
    // }
    setLoading(true);
    try {
      let data = {
        // fromDate: startDate,
        // toDate: endDate,
        fromDate: startDate != '' ? startDate : filteredDate?.startDate,
        toDate: endDate != '' ? endDate : filteredDate?.endDate,
        ownerName: rm,
        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
        asm: userData?.role == 'asm' ? userData?.id : asm
      }
      let result = await window.Platform.database.exportData("expense/downloadExpenseTADAExcel",
        data
      )
      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const now = new Date();
      const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `TADA_Report_${formattedDate}.xlsx`);
      // link.setAttribute("download", "attendance.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Export error:", error);
    }
  }

  const handleTabChange = async (value, keepSelected = false) => {
    setVisibleEmployees([]);
    if (!keepSelected) {
      setSelectedMember(null);
    }
    setFilter(false);
    setSelectedTab(value);
  };

  const fetchEmployees = async () => {
    setLoading(true);
    try {
      setVisibleEmployees([]);

      let results = await window.Platform.database.getExpenseTADA({
        pageNumber: paginationModel.page,
        recordPerPage: paginationModel.pageSize,
        ownerName: rm,
        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
        asm: userData?.role == 'asm' ? userData?.id : asm,
        // fromDate: startDate,
        // toDate: endDate,
        fromDate: startDate != '' ? startDate : filteredDate?.startDate,
        toDate: endDate != '' ? endDate : filteredDate?.endDate,
        approvalStatus: allowanceStatus,
        forWeb: true
      });
      setNewRows(results?.data)
      setRowCount(results?.data1)

      const jsonArrayWithId = results?.data?.map((obj, index) => ({
        ...obj,
        id: index + 1,
      }));
      setVisibleEmployees(jsonArrayWithId);
      // setLoading(false);
      if (results.status) {
        setLoading(false);
      } else {
        setLoading(false);
        window.NotificationUtils.showError(results.message);
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const getUpdatedAllowances = async () => {
    setLoading(true);
    try {
      setVisibleEmployees([]);

      let results = await window.Platform.database.getUpdatedAllowances({});
      // setNewRows(results?.data)
      // setRowCount(results?.data1)

      // const jsonArrayWithId = results?.data?.map((obj, index) => ({
      //   ...obj,
      //   id: index + 1,
      // }));
      // setVisibleEmployees(jsonArrayWithId);
      // setLoading(false);
      // if (results.status) {
      //   setLoading(false);
      // } else {
      //   setLoading(false);
      //   window.NotificationUtils.showError(results.message);
      // }
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const clearFilter = async () => {
    setLoading(true);
    setRsm("");
    setAsm("");
    setRm("");
    setStartDate("")
    setEndDate("")
    setAllowanceStatus("")
    setRsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'rsm'));
    setRms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'se'));
    setAsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'asm'));
    setSelectedSession("");
    setVisibleEmployees([]);
    setRowCount(0);
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth(); // 0-based
    const day = now.getDate();

    let start, end;

    if (day <= 15) {
      start = new Date(year, month, 1);
      end = new Date(year, month, 15);
    } else {
      start = new Date(year, month, 16);
      end = new Date(year, month + 1, 0); // last day of the month
    }
    setStartDate(start.toLocaleDateString('en-CA'))
    setEndDate(end.toLocaleDateString('en-CA'))
    setLoading(false);
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />

        <GridToolbarFilterButton />

        {/* <GridToolbarDensitySelector /> */}

        <GridToolbarExport
          csvOptions={{
            fileName: "users-report",
          }}
        />
      </GridToolbarContainer>
    );
  }
  const renderTabContent = () => {
    return (<>
      {/* <div className="d-flex  align-items-center  py-2"> */}
        {/* <Button
          onClick={() => setNewOrderStatus("")}
          style={{ backgroundColor: newOrderStatus === "" ? "#8787f470" : "white", color: newOrderStatus === "" ? "#000000" : "black", fontWeight: "500", }}>
          All
        </Button>
        <Button
          onClick={() => setNewOrderStatus(0)}
          style={{ backgroundColor: newOrderStatus === 0 ? "blue" : "white", color: newOrderStatus === 0 ? "white" : "black", fontWeight: "500", }}>
          Verified
        </Button>
        {userData?.role != "asm" && <> <Button
          onClick={() => setNewOrderStatus(1)}
          style={{ backgroundColor: newOrderStatus === 1 ? "green" : "white", color: newOrderStatus === 1 ? "white" : "black", fontWeight: "500", }}>
          Approved
        </Button>
        </> } */}
        <Box display="flex" justifyContent="space-between" gap={0} mb={1}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              px: 2,
              py: 1,
              background: "#e8f5e9",
              border: "1px solid #a5d6a7",
              borderLeft: "4px solid #2e7d32",
              borderRadius: "8px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
              width: "fit-content",
            }}
          >
            <Typography
              sx={{
                fontSize: "13px",
                fontWeight: 600,
                color: "#1b5e20",
                letterSpacing: "0.3px",
              }}
            >
              Total Entries:
            </Typography>
            <Typography
              sx={{
                fontSize: "15px",
                fontWeight: 700,
                color: "#2e7d32",
                background: "#fff",
                px: 1.2,
                py: 0.2,
                borderRadius: "6px",
                border: "1px solid #a5d6a7",
                minWidth: "28px",
                textAlign: "center",
              }}
            >
              {visibleEmployees?.length > 0 ? rowCount : 0 || 0}
            </Typography>
          </Box>
          <Box sx={{display:"flex", justifyContent:"center", alignItems:"center"}}>
            <Typography variant="body1" ml={3} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select Page Size:&nbsp; </Typography>
            <Select
              value={paginationModel.pageSize}
              variant="outlined"
              size="small"
              onChange={(e) => { setPaginationModel({ ...paginationModel, pageSize: e.target.value }) }}
              sx={{ width: 90, fontSize: 13, fontWeight: "500" }}
            >
              {[10, 20, 30, 50, 100].map((role) => (
                <MenuItem key={role} value={role} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role}</MenuItem>
              ))}
            </Select>
          </Box>
        </Box>
      {/* </div> */}
      <DataGridContainer
        style={{ height: !visibleEmployees.length ? "200px" : "auto" }}
      >
        <DataGrid
          className="payrollGrid"
          density="compact"
          rows={visibleEmployees || []}
          columns={schoolColumns()}
          sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}

          disableSelectionOnClick
          disableRowSelectionOnClick

          onRowClick={(rowParams, event) => {
            setUserModal(rowParams.row);
          }}
          rowHeight={60}
          rowCount={rowCount}
          paginationModel={paginationModel}
          paginationMode="server"
          onPaginationModelChange={setPaginationModel}
        />
      </DataGridContainer>
    </>
    );
  };

  return (
    <>
      <StaffEditorPageContainer>
        <HeaderContainer>
          <Box sx={{ mt: 1, width: "100%" }}>

            <Paper elevation={3}
              sx={{
                p: 2,
                mb: 2,
                width: '100%',        // takes full width of parent
                // maxWidth: '1000px',   // optional: control max width
                mx: 'auto',
                backgroundColor: "#ebf0fa"          // center it horizontally
              }}>
              <div className="container-fluid" style={{ width: "100%" }}>
                <div className="row">
                  {userData?.role.includes('admin') && <div className="col-md-3">
                    <FormControl fullWidth size="small">
                      <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select HO</InputLabel>
                      <Select
                        value={rsm}
                        label="Select HO"
                        size="small"
                        onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value); setAsm(""); setRm("") }}
                      >
                        <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                        {rsms.map((role) => (
                          <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>}
                  {userData?.role != 'asm' && <div className="col-md-3">
                    <FormControl size="small" fullWidth>
                      <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select ARM</InputLabel>
                      <Select
                        value={asm}
                        label="Select ARM"
                        size="small"
                        onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value); setRm(""); }}
                      >
                        <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                        {asms.map((role) => (
                          <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>}
                  <div className="col-md-3">
                    <FormControl size="small" fullWidth>
                      <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select RM:</InputLabel>
                      <Select
                        value={rm}
                        label="Select RM"
                        size="small"
                        onChange={(e) => { setRm(e.target.value) }}
                      >
                        <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                        {rms.map((role) => (
                          <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  {accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no" && <div className="col-md-3">
                    <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ borderRadius: "10px" }} onClick={() => { exportTADAExcel() }}>Download</Button>
                  </div>}
                </div>
                <div className="row mt-2">
                  <div className="col-md-3">
                    <FormControl fullWidth size="small">
                      <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Status</InputLabel>
                      <Select label="Select Status" value={allowanceStatus} size="small" onChange={(e) => { setAllowanceStatus(e.target.value); }} sx={{ width: '100%', fontSize: 14 }}>
                        <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "400" }} >All</MenuItem>
                        <MenuItem key={1} value={"pending"} sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>Pending</MenuItem>
                        <MenuItem key={2} value={"verified"} sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>Verified</MenuItem>
                        <MenuItem key={3} value={"approved"} sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}>Approved</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="col-md-2">
                    <FormControl fullWidth size="small">
                      <TextField label="From Date" size="small" type="date" sx={{ color: "black", fontSize: "13px", fontWeight: 500 }} className="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)}
                        InputLabelProps={{
                          shrink: true,
                          style: { color: "black", fontSize: "13px", fontWeight: 500 }
                        }}
                        inputProps={{
                          style: { color: "black", fontSize: "13px", fontWeight: 500 }
                        }} />
                    </FormControl>
                  </div>
                  <div className="col-md-2">
                    <FormControl fullWidth size="small">
                      <TextField label="To Date" size="small" type="date" sx={{ color: "black", fontSize: "13px", fontWeight: 500 }} className="form-control" value={endDate} onChange={(e) => setEndDate(e.target.value)}
                        InputLabelProps={{
                          shrink: true,
                          style: { color: "black", fontSize: "13px", fontWeight: 500 }
                        }}
                        inputProps={{
                          style: { color: "black", fontSize: "13px", fontWeight: 500 }
                        }} />
                    </FormControl>
                  </div>
                  <div className="col-md-2">
                    <Button variant="contained" size="small" startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />} color="primary" fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => fetchEmployees()}>
                      Find
                    </Button>
                  </div>
                  <div className="col-md-3">
                    <Button variant="contained" startIcon={<img src={clearFilterImage} alt="icon" height={"21"} width={"21"} />} color="secondary" size="small" fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => clearFilter()}>
                      Clear Filters
                    </Button>
                  </div>
                </div>
                <div className="row mt-2">
                  {/* <div className="col-md-3">
                                                        <FormControl fullWidth size="small">
                                                          <InputLabel
                                                            sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}
                                                          >
                                                            Select Session
                                                          </InputLabel>
                                                          <Select
                                                            label="Select Session"
                                                            value={selectedSession}
                                                            disabled={isSessionDisabled}
                                                            sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}
                                                            onChange={(e) => {
                                                              const selected = sessions.find((item) => item.id === e.target.value);
                                                              setSelectedSession(e.target.value);
                                    
                                                              if (selected) {
                                                                // ✅ Convert UTC → IST (local date)
                                                                const start = new Date(selected.startDate);
                                                                const end = new Date(selected.endDate);
                                    
                                                                const startIST = new Date(start.getTime() + (5.5 * 60 * 60 * 1000))
                                                                  .toISOString()
                                                                  .split("T")[0];
                                                                const endIST = new Date(end.getTime() + (5.5 * 60 * 60 * 1000))
                                                                  .toISOString()
                                                                  .split("T")[0];
                                    
                                                                setStartDate(startIST);
                                                                setEndDate(endIST);
                                    
                                                                // ✅ Disable manual date range if session chosen
                                                                setIsDateRangeDisabled(true);
                                                              } else {
                                                                // ✅ If cleared, re-enable date inputs
                                                                setIsDateRangeDisabled(false);
                                                              }
                                                            }}
                                    
                                                          >
                                                            <MenuItem value="">
                                                              <em>Select Session</em>
                                                            </MenuItem>
                                                            {sessions.map((s) => (
                                                              <MenuItem key={s.id} value={s.id}>
                                                                {s.sessionName}
                                                              </MenuItem>
                                                            ))}
                                                          </Select>
                                                        </FormControl>
                                                      </div> */}
                </div>
              </div>
            </Paper>
          </Box>
        </HeaderContainer>
        <TableContainer>
          <TabsContainer>
            {/* <StyledTabs
              variant="fullWidth"
              value={selectedTab}
              onChange={(event, value) => handleTabChange(value)}
              indicatorColor="primary"
              textColor="primary"
            > */}
            {/* <Tab label="Travel Allowance" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }} /> */}
            {/* {<Tab label="Daily Allowance" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }} />} */}
            {/* </StyledTabs> */}
            {loading && <OpaqueLoading />}

            {renderTabContent()}
          </TabsContainer>
        </TableContainer>
      </StaffEditorPageContainer>

      <Modal open={verifyModalOpen} onClose={() => setVerifyModalOpen(false)}>
        <Box sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 800,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}>
          <Typography variant="h6" mb={2} sx={{ fontWeight: "800", color: "black" }} textAlign="center">Verify Allowance</Typography>
          {/* <Typography variant="h6" mb={2} sx={{ fontWeight: "800", color: "black" }} textAlign="center">Verify Allowance  ({verifyModalData?.data1?.name} - {new Date(verifyModalData?.data1?.visitDate).toLocaleDateString('en-GB')})</Typography> */}
          <Stack direction="row" spacing={2} mb={2}>
            <Typography sx={{ fontWeight: "700", color: "black", display: "flex", alignItems: "center" }}>Select Distance Type: </Typography>
            <Button
              variant={selectedDistanceType === "user" ? "contained" : "outlined"}
              color="primary"
              onClick={() => setSelectedDistanceType("user")}
            >
              User Reported Distance <br /> ({verifyModalData?.data1?.userGeneratedDistance || "N/A"})
            </Button>
            <Button
              variant={selectedDistanceType === "system" ? "contained" : "outlined"}
              color="secondary"
              onClick={() => setSelectedDistanceType("system")}
            >
              System Generated Distance <br /> ({verifyModalData?.data1?.systemGenerated_distance || "N/A"})
            </Button>
          </Stack>
          {/* <TextField
            label="Verify Remark"
            fullWidth
            multiline
            minRows={2}
            value={verifyRemark}
            onChange={e => setVerifyRemark(e.target.value)}
            sx={{ mb: 2 }}
          /> */}
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button variant="outlined" onClick={() => {
              setVerifyModalOpen(false);
              setSelectedDistanceType("");
              // setVerifyRemark("");
            }}>Cancel</Button>
            <Button
              variant="contained"
              color="success"
              disabled={!selectedDistanceType}
              onClick={() => {
                const selectedDistance = selectedDistanceType === "user"
                  ? verifyModalData?.data1?.userGeneratedDistance == "Auto Out" ? null : verifyModalData?.data1?.userGeneratedDistance
                  : verifyModalData?.data1?.systemGenerated_distance;
                verifyAllowance(verifyModalData, selectedDistance);
              }}
            >
              Submit
            </Button>
          </Stack>
        </Box>
      </Modal>

      <Modal open={approveModalOpen} onClose={() => setApprovedModalOpen(false)}>
        <Box sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 800,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}>
          <Typography variant="h6" mb={2} sx={{ fontWeight: "800", color: "black" }} textAlign="center"> {approvedModalData?.status == 1 ? "Approve Allowance" : "Reject Allowance"} </Typography>
          <h4 style={{ color: "black", fontWeight: "500" }}>
            Name :- {approvedModalData?.data1?.name}
          </h4>
          <h4 style={{ color: "black", fontWeight: "500" }}>
            Verified Amount :- {approvedModalData?.data1.verifiedAmount || 0}
          </h4>
          <h4 style={{ color: "black", fontWeight: "500" }}>
            Verified By :- {approvedModalData?.data1?.verifyByName}
          </h4>
          <h3 style={{ color: "black", fontWeight: "500" }} >
            You Are About to Approve KM Travelled by User and Verified by Manager. Are you sure to Proceed?
          </h3>
          <TextField
            label="Remark"
            fullWidth
            multiline
            value={approvedRemark}
            onChange={handleApprovedRemarkChange}
            sx={{ mb: 2 }}
          />

          <Stack direction="row" spacing={2} justifyContent="flex-end">

            <Button variant="outlined" onClick={() => {
              setApprovedModalOpen(false);
              setApprovedRemark("");
            }}>Cancel</Button>
            <Button
              variant="contained"
              color="success"
              disabled={approvedModalData?.status == 2 && !approvedRemark}
              onClick={() => {
                approveAllowance(approvedModalData);
              }}
            >
              Submit
            </Button>

          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default Allowances;
